// Copyright (c) Zammo Inc.
import React, { memo, useEffect, useRef } from 'react';

import { Wrapper, ChatBubbleBot, ChatContainer, ChatBubbleUser } from './styles';

export type MessageSummary = {
  text: string;
  user: string;
};

type Props = {
  messages: MessageSummary[];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const resetScrollEffect = (element: any) => {
  if (element.current) {
    element.current.scrollTop = element.current.scrollHeight;
  }
};

const VoiceChatSummary = ({ messages }: Props) => {
  const wrapperRef = useRef(null);
  useEffect(() => resetScrollEffect(wrapperRef), [messages]);

  const chatBubbles = messages.map((message: MessageSummary) => (
    <>
      <ChatContainer>
        {message.user === 'bot' && <ChatBubbleBot>{message.text}</ChatBubbleBot>}
        {message.user !== 'bot' && <ChatBubbleUser>{message.text}</ChatBubbleUser>}
      </ChatContainer>
    </>
  ));

  return <Wrapper ref={wrapperRef}>{chatBubbles}</Wrapper>;
};

export default memo(VoiceChatSummary);
